import React from "react";
import { Container } from "components/Container";
import { WeddingCardSection } from "components/WeddingCardSection";
import { PineappleCoconutCrispSection } from "components/BlackSugarEggRollSection";
import { PromotionFooter } from "components/PromotionFooter";
import { PineappleCakeSection } from "components/PineappleCakeSection";

export const App = React.memo(() => {
  return (
    <Container>
      <WeddingCardSection />
      <PineappleCakeSection />
      <PineappleCoconutCrispSection />
      <PromotionFooter />
    </Container>
  );
});
